import "./Services.css";  
import app from '../../images/app-development.png'
import web from '../../images/coding.png'
import software from '../../images/software-development.png'
import api from '../../images/cloud-computing.png'

const Services = () => {
  return (
    <>
      <section id="services">
        <div className="service-container">
          <div className="service-title">
            <h2>What Service i Offer you</h2>

            <h3>Services</h3>
          </div>

          <div className="service-row">
            <div
              className=" my-service"
              data-aos="zoom-in-up"
              data-aos-duration="1500"
            >
              <div className="ser-back">
                <img
                src={web}
                   alt=""
                />
              </div>
              <h4 className="web">Web Development</h4>
              <p className="service-info">
                {" "}
                As a Web developer use coding languages like HTML, CSS,
                JavaScript, and php to build websites and web applications.
              </p>

              <div class="shadow-icon">
                <i class=""></i>
              </div>
            </div>
            {/* 2 */}
            <div
              className=" my-service"
              data-aos="zoom-in-up"
              data-aos-duration="1500"
            >
              <div className="ser-back">
                <img
                 src={api}
                   alt=""
                />
              </div>
              <h4 className="web">Api Integration</h4>
              <p className="service-info">
                I offer API integration service in existing applications or in
                software I create from scratch.
              </p>

              <div class="shadow-icon">
                <i class=""></i>
              </div>
            </div>
            <div
              className=" my-service"
              data-aos="zoom-in-up"
              data-aos-duration="1500"
            >
              <div className="ser-back">
                <img
                 src={software}
                   alt=""
                />
              </div>
              <h4 className="web">Software Development</h4>
              <p className="service-info">
                I offer world-class custom software development services
                designed specifically for your business and ready to satisfy
                your exclusive needs.
              </p>

              <div class="shadow-icon">
                <i class=""></i>
              </div>
            </div>
            {/* 4 */}
            <div
              className=" my-service"
              data-aos="zoom-in-up"
              data-aos-duration="1500"
            >
              <div className="ser-back">
                <img
                 src={app}
                   alt=""
                />
              </div>
              <h4 className="web">App Development</h4>
              <p className="service-info">
                {" "}
                As a app developer use coding languages like react native and
                flutter, to build android .
              </p>

              <div class="shadow-icon">
                <i class=""></i>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
